import script from "./UserHeaderTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserHeaderTotals.vue?vue&type=script&setup=true&lang=ts"

import "./UserHeaderTotals.vue?vue&type=style&index=0&id=060d7a52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060d7a52"]])

export default __exports__